module.exports = __webpack_public_path__ + "img/delivery.7692d410.svg";